import React, { useState } from "react";

export type SelectProps = {
    id: string;
    onChange: (value: React.ChangeEvent<HTMLSelectElement>) => void;
    className?: string;
    name: string;
    value: string | undefined;
    title: string;
    options: Options[];
    placeHolder?: string;
    errorDiv?: string;
    errorMsg?: string;
}

export type Options = {
    id: string;
    value: string;
}

const Select = (props:SelectProps) => {
    const [selectedValue, setSelectedValue] = useState(props.value);

    const handleChange = (event:React.ChangeEvent<HTMLSelectElement>) => {
        props.onChange(event)
        setSelectedValue(event.currentTarget.value);
    }

    return (


        <div className="form__select">
            <label htmlFor={props.name} className="form__select-label">
                {props.title}
            </label>
            <div className="form__select-field">

                <select
                    className={props.className}
                    name={props.name}
                    id={props.name}
                    value={selectedValue}
                    onChange={handleChange}
                >
                    <option value="">{props.placeHolder}</option>
                    {props.options.map((o) => {
                        return (
                            <option
                                className="form__select-option"
                                id={o.id.toString()}
                                key={o.id}
                                value={o.value}
                            >
                                {o.value}
                            </option>
                        )
                    })}
                </select>
                <div className="form__error">{props.errorMsg}</div>
            </div>
        </div>
    )
}
export default Select;